import { call, put } from "redux-saga/effects";

import { api, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { CreateTransportFileActions } from "store/ducks/transport-files";

export function* createTransportFileRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      api.post,
      `/transport-files`,
      postData
    );

    const { data } = responseBody;
    yield put(CreateTransportFileActions.success(data));
    notify("success", "Documento enviado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreateTransportFileActions.failure(errorMessage));
  }
}